<template>
  <div class="wrapper">
    <FORM  ref="childForm"  @formclick="formclick" :formData="formData"></FORM>
    <table-page ref="childTable"  :pageData="pageData"></table-page>
  </div>
</template>

<script>
    //table封装组件
    import tablePage from '@/components/page/table.vue'
    import FORM from '@/components/page/form.vue'
    import URL from '@/views/newmis36/util/url'
    import DateUtil from '@/utils/IM/tradeDataUtil.js'
    import download from '@/utils/download'
    let userType = {"default":"全部","real":"真实","demo":"模拟"};
    let levelType = {"MIN":"迷你","STD":"标准","PLA":"铂金","AGT":"AGT","ZER":"巴菲特","MIN2":"迷你2","STD2":"标准2","PLA2":"铂金2"};
    let channel = {1:"前台",0:"手机"};
    //let businessType = {"default":"CFVN","CFVNC":"CFVNC"};
    let dates=new Date();
    let teamList = {};
    let countryList = {"ISO_3166_704":"越南","ISO_3166_356":"印度"};
    export default {
        name: 'list',
        components: {
            tablePage,
            FORM
        },
        created() {
            this.resetSearch();
        },
        methods: {
            /*查询表单按钮点击事件*/
            formclick(clickName, data){
                if("查询" == clickName || window.$t('txmis.bt.search') == clickName){
                    let param = JSON.parse(JSON.stringify(data));
                    if (param.customerNo || param.phone) {
                        param.openStartTime = "";
                        param.openEndTime = "";
                        param.activeStartTime = "";
                        param.activeOpenTime = "";
                    }
                    param.userType = param.userType === "default" ? "" : param.userType;
                    this.queryData = param;
                    if (this.ishaveTeamList) this.$refs.childTable.defaultQueryData(param);
                    else this.getCountryListAndTeamList();
                }else if(window.$t('txmis.tracker.isShow') == clickName){
                    this.pageData.isShow = !this.pageData.isShow;
                }else if(window.$t('txmis.bt.down') == clickName){
                    //隐藏关键字段
                    const param = Object.assign(JSON.parse(JSON.stringify(data)), {exportHide:true});
                    download.exportExcel(URL.tracker.export,param,window.$t('txmis.tracker.tracker'));
                }else if(window.$t('txmis.bt.export') == clickName){
                    const param = Object.assign(JSON.parse(JSON.stringify(data)), {});
                    download.exportExcel(URL.tracker.export,param,window.$t('txmis.tracker.tracker'));
                }else if(window.$t('txmis.tracker.day') == clickName){
                    //this.resetSearch();
                    let now = new Date();
                    this.formData.cols[4].data = this.dateToString(this.formatDate(now)+" 00:00:00");
                    this.formData.cols[5].data = this.dateToString(this.formatDate(now)+" 23:59:59");
                    this.formData.cols[2].data = "";
                    this.formData.cols[3].data = "";
                    this.$refs.childForm.change();
                    this.$refs.childForm.formclick( {click: window.$t('txmis.bt.search')});
                }else if(window.$t('txmis.tracker.week') == clickName){
                    //this.resetSearch();
                    let now = new Date();
                    let day =now.getDay();
                    if(day==0){
                        day=7;
                    }
                    now.setDate(now.getDate()-day+1);
                    this.formData.cols[4].data=this.dateToString(this.formatDate(now)+" 00:00:00");
                    this.formData.cols[5].data=this.dateToString(this.formatDate(dates)+" 23:59:59");
                    this.formData.cols[2].data="";
                    this.formData.cols[3].data="";
                    this.$refs.childForm.change();
                    this.$refs.childForm.formclick( {click: window.$t('txmis.bt.search')});
                }else if(window.$t('txmis.tracker.month') == clickName){
                    //this.resetSearch();
                    let now = new Date();
                    now.setDate(1);
                    this.formData.cols[4].data = this.dateToString(this.formatDate(now)+" 00:00:00");
                    this.formData.cols[5].data = this.dateToString(this.formatDate(dates)+" 23:59:59");
                    this.formData.cols[2].data = "";
                    this.formData.cols[3].data = "";
                    this.$refs.childForm.change();
                    this.$refs.childForm.formclick( {click: window.$t('txmis.bt.search')});
                }else if(window.$t('txmis.tracker.reset') == clickName){
                    this.resetSearch();
                    let now = new Date();
                    this.formData.cols[2].data = this.dateToString(this.formatDate(now)+" 00:00:00");
                    this.formData.cols[3].data = this.dateToString(this.formatDate(dates)+" 23:59:59");
                    this.$refs.childForm.change();
                    let param = {};
                    param.openStartTime = this.formData.cols[2].data;
                    param.openEndTime = this.formData.cols[3].data;
                    this.queryData = param;
                    this.$refs.childTable.defaultQueryData(param);
                }
            },
            getCountryListAndTeamList(){
                //获取国家列表
                this.$axios.post(URL.country.list).then(res => {
                    if (res.code == 0){
                        if (res.result){
                            for (let i in res.result) {
                                countryList[res.result[i].code] = res.result[i].nameCn;
                            }
                        }
                        //获取团队列表
                        console.log("获取国家列表");
                        this.$axios.post(URL.team.list).then(res => {
                            if (res.code == 0){
                                if (res.result){
                                    for (let i in res.result) {
                                        teamList[res.result[i].id] = res.result[i].name;
                                    }
                                }
                                this.ishaveTeamList = true;
                                this.$refs.childTable.defaultQueryData(this.queryData);
                            }
                        });
                    }
                });
            },
            resetSearch(){
                this.formData.cols = [];
                let now = new Date();
                this.start=this.dateToString(this.formatDate(now)+" 00:00:00");
                this.end=this.dateToString(this.formatDate(dates)+" 23:59:59");
                this.formData.cols = [
                  { title: window.$t('txmis.tracker.customerNo'), field: 'customerNo'},
                  { title: window.$t('txmis.common.phone'), field: 'phone'},
                  { title: window.$t('txmis.tracker.openStartTime'), field: 'openStartTime',data:this.start,type:5},
                  { title: window.$t('txmis.tracker.openEndTime'), field: 'openEndTime',data:this.end,type:5},
                  { title: window.$t('txmis.tracker.activeStartTime'), field: 'activeStartTime',type:5},
                  { title: window.$t('txmis.tracker.activeEndTime'), field: 'activeOpenTime',type:5},
                  { title: window.$t('txmis.tracker.userType'), field: 'userType',type:2,optionList:userType,data:'default'},
                  { title: window.$t('txmis.tracker.isActive'), field: 'isActive',type:2,optionList:{"1":"激活","0":"未激活"}},
                  { title: window.$t('txmis.tracker.utmSource'), field: 'utmSource'},
                  { title: window.$t('txmis.tracker.utmMedium'), field: 'utmMedium'},
                  { title: "ip", field: 'ip'},
                 /* { title: window.$t('txmis.registerLog.businessType'), field: 'mulBusinessType',type:2,optionList:businessType},*/
                  { title: window.$t('txmis.registerLog.agentCode'), field: 'agentCode'},
                  { title: window.$t('txmis.tracker.countryCode'), field: 'countryCode',type:2,optionList:countryList},
                  {click: window.$t('txmis.bt.search'),auth:"tracker.search"},
                  {click: window.$t('txmis.bt.down'),auth:"tracker.down"},
                  {click: window.$t('txmis.bt.export'),auth:"tracker.export"},
                  {click: window.$t('txmis.tracker.isShow')},
                  {click: window.$t('txmis.tracker.day')},
                  {click: window.$t('txmis.tracker.week')},
                  {click: window.$t('txmis.tracker.month')},
                  {click: window.$t('txmis.tracker.reset')},
                ];
            },
            dateToString(data){
                let date = data.replace(/-/g,'/'); //必须把日期'-'转为'/'
                return new Date(date).getTime();
            },
            formatDate(data){
                var yy = data.getFullYear();      //年
                var mm = data.getMonth() + 1;     //月
                var dd = data.getDate();          //日
                var clock = yy + "-";
                if(mm < 10) clock += "0";
                clock += mm + "-";
                if(dd < 10) clock += "0";
                clock += dd + " ";
                return clock;
            },
        },
        data () {
            return {
                ishaveTeamList:false,
                startDate:'',
                endDate:'',
                queryData:{},
                /*新增或更新*/
                /*from查询表单*/
                formData:{
                    hasLable: true,
                    cols:[]
                },
                /*table生成*/
                pageData: {
                    isShow: false,
                    queryUrl: URL.tracker.query, //请求路径和参数
                    sequence: true,
                    size:50,
                    pageSizes:[10,50,100,500],
                    checkList:[
                        //window.$t('txmis.tracker.team'),
                        window.$t('txmis.tracker.countryCode'),
                        window.$t('txmis.tracker.customerNo'),
                        window.$t('txmis.tracker.relatedAccount'),
                        //window.$t('txmis.common.name'),
                        window.$t('txmis.tracker.userType'),
                        window.$t('txmis.tracker.levelType'),
                        //window.$t('txmis.common.phone'),
                        //window.$t('txmis.common.email'),
                        //window.$t('txmis.common.idNumber'),
                        //window.$t('txmis.tracker.userAge'),
                        //window.$t('txmis.tracker.gender'),
                        //window.$t('txmis.tracker.birthday'),
                        window.$t('txmis.tracker.ctime'),
                        //window.$t('txmis.tracker.nkey'),
                        //window.$t('txmis.tracker.creditLevel'),
                        //window.$t('txmis.tracker.href'),
                        window.$t('txmis.tracker.utmSource'),
                        window.$t('txmis.tracker.utmMedium'),
                        window.$t('txmis.tracker.utmCampaign'),
                        //window.$t('txmis.tracker.utmContent'),
                        //window.$t('txmis.tracker.utmTerm'),
                        window.$t('txmis.tracker.referrer'),
                        window.$t('txmis.tracker.channel'),
                        window.$t('txmis.tracker.isActive'),
                        window.$t('txmis.tracker.activeTime'),
                        "ip",
                        window.$t('txmis.tracker.ipAddress'),
                        //window.$t('txmis.tracker.userAgent'),
                        window.$t('txmis.common.remark'),
                        window.$t('txmis.tracker.directPhone'),
                        window.$t('txmis.tracker.mediaSource'),
                        window.$t('txmis.tracker.campaign'),
                        window.$t('txmis.tracker.afChannel'),
                        window.$t('txmis.tracker.afPrt'),
                        window.$t('txmis.tracker.installTime'),
                      /*  window.$t('txmis.registerLog.businessType'),*/
                        window.$t('txmis.registerLog.agentCode'),
                    ],
                    cols: [
                        {title: window.$t('txmis.tracker.team'), field: 'team',render:(data)=>{
                            if (!data) return "";
                            return teamList[data];
                        }},
                        {title: window.$t('txmis.tracker.countryCode'), field: 'countryCode',render:(data)=>{
                            if (!data) return "";
                            return countryList[data];
                        }},
                        {title: window.$t('txmis.tracker.customerNo'), field: 'customerNo'},
                        {title: window.$t('txmis.tracker.relatedAccount'), field: 'relatedAccount'},
                        {title: window.$t('txmis.common.name'), field: 'userName'},
                        {title: window.$t('txmis.tracker.userType'), field: 'userType',render:(data)=>{return userType[data];}},
                        {title: window.$t('txmis.tracker.levelType'), field: 'levelType',render:(data)=>{return levelType[data];}},
                        {title: window.$t('txmis.common.phone'), field: 'phone'},
                        {title: window.$t('txmis.common.email'), field: 'email'},
                        {title: window.$t('txmis.common.idNumber'), field: 'idCard'},
                        {title: window.$t('txmis.tracker.userAge'),field: 'userAge'},
                        {title: window.$t('txmis.tracker.gender'),field: 'gender'},
                        {title: window.$t('txmis.tracker.birthday'),field: 'birthday'},
                        {title: window.$t('txmis.tracker.ctime'),field: 'ctime',render:(data)=>{
                                return DateUtil.formatDate(data,"yyyy-MM-dd hh:mm:ss");
                            }},
                        {title: window.$t('txmis.tracker.nkey'),field: 'paySwitchSeqTagCode'},
                        {title: window.$t('txmis.tracker.creditLevel'), field: 'creditLevel'},
                        {title: window.$t('txmis.tracker.href'), field: 'href'},
                        {title: window.$t('txmis.tracker.utmSource'), field: 'utmSource'},
                        {title: window.$t('txmis.tracker.utmMedium'), field: 'utmMedium'},
                        {title: window.$t('txmis.tracker.utmCampaign'), field: 'utmCampaign'},
                        {title: window.$t('txmis.tracker.utmContent'), field: 'utmContent'},
                        {title: window.$t('txmis.tracker.utmTerm'), field: 'utmTerm'},
                        {title: window.$t('txmis.tracker.mediaSource') ,field:'mediaSource'},
                        {title: window.$t('txmis.tracker.campaign'),field:'campaign'},
                        {title: window.$t('txmis.registerLog.agentCode'),field:'agentCode'},
                        {title: window.$t('txmis.tracker.afChannel'),field:'afChannel'},
                        {title: window.$t('txmis.tracker.afPrt'),field:'afPrt'},
                        {title: window.$t('txmis.tracker.installTime'),field:'installTime'},
                        {title: window.$t('txmis.tracker.referrer'), field: 'referrer'},
                        {title: window.$t('txmis.tracker.channel'), field: 'channel',render:(data)=>{
                                if(data==1) return "前台";
                                if(data==0) return "手机";
                                return "后台";
                            }},
                        { title: window.$t('txmis.tracker.isActive'), field: 'activeTime',render:(data)=>{
                                if (data > 0) {
                                    return "已激活";
                                } else {
                                    return "未激活";
                                }
                        }},
                        {title: window.$t('txmis.tracker.activeTime'),field: 'activeTime',render:(data)=>{
                                return DateUtil.formatDate(data,"yyyy-MM-dd hh:mm:ss");
                            }},
                        {title: "ip", field: 'ip'},
                        {title: window.$t('txmis.tracker.ipAddress'),field:'ipAddress'},
                        {title: window.$t('txmis.tracker.userAgent'),field:'userAgent'},
                        {title: window.$t('txmis.common.remark'),field:'remark'},
                        {title: window.$t('txmis.tracker.directPhone'),field:'directPhone'},
                       /* { title: window.$t('txmis.registerLog.businessType'), field: 'businessType',render:(data,full)=>{
                          return businessType[data];
                        }},*/

                    ]
                }
            }
        }
    }
</script>
